import Papa from 'papaparse';
import * as FS from 'file-saver';

export default{
    name: 'TablesMixin',
    data () {
        return {
            //
            paginationEvent: 'updatePaginationText',
            isMobile: false,
            asyncComponent: null,
            tableTypeMinimal: false,
            canScroll: 'scrollable',
            width: 0,
            height: 'auto',
            currentPage: 1,
            loading: false,
            shownPagination: true,
            showSummary: false,
            search: '',
            paginationInfo: {
                //text: `<span><strong>20</strong> per page</span>`,
                pageSize: 20,
                nextPageText: '›',
                prevPageText: '‹' 
            },
            defaultListResult: { 
                items: [], 
                paginationInfo: {
                    //text: `<span><strong>20</strong> per page</span>`,
                    pageSize: 20,
                    nextPageText: '›',
                    prevPageText: '‹' 
                }
            },
            sortingProp: "birth_day", 
            sortingOrder: "descending",
            list: [],
            selectedItems: []
        }
  },
    computed: {
		listFiltered() {
			return this.list.filter((obj) => {
				let ctrl = false
				for(let k in obj) {
					if(obj[k] && obj[k].toString().toLowerCase().indexOf(this.search.toLowerCase()) !== -1) ctrl = true
				}
				return ctrl
			})
		},
		listSortered() {
			let prop = this.sortingProp
			let order = this.sortingOrder
			return [].concat(this.listFiltered.sort((item1, item2) => {
				let val1 = '';
				let val2 = '';

				/*if (prop === 'formatted_date') {
					val1 = parseInt(moment(item1[prop], 'DD/MM/YYYY').format('x'))
					val2 = parseInt(moment(item2[prop], 'DD/MM/YYYY').format('x'))
					if (order === 'descending') {
						return val2 < val1 ? -1 : 1
					}
					return val1 < val2 ? -1 : 1
				}*/

				val1 = item1[prop];
				val2 = item2[prop]
				if (order === 'descending') {
					return val2 < val1 ? -1 : 1
				}
				return val1 < val2 ? -1 : 1
			}))
		},
		listInPage() {
			let from = (this.currentPage - 1) * this.pageSize
			let to = from + (this.pageSize*1)
			return this.listSortered.slice(from, to)
		},
		total() {
			return this.paginationInfo.total
		},
		pageSize() {
			return this.paginationInfo.pageSize
		},
		selectedIds() {
			var ids = [];
			if(this.selectedItems)
				ids = this.selectedItems.map(p=> p.id);

			return ids;
		}
	},
	watch: {
		total(val) {
			this.updatePaginationText()
		},
		asyncComponent(val) {
			this.updatePaginationText()
		},
		pageSize(val) {
			this.asyncComponent = null
			this.currentPage = 1

			setTimeout(() => {
				this.asyncComponent = 'v2-table'
			}, 500);
		},
		search(val) {
			this.currentPage = 1
		},
		currentPage(val) {
			this.$refs.table.curPage = val
		}
	},
    methods: {
		updatePaginationText() {
            this.calcDims();
			this.paginationInfo.text = `<span>Total of <strong>${this.total}</strong>, <strong>${this.paginationInfo.pageSize}</strong> per page</span>`
		},
		handlePageChange(page) {
            this.currentPage = page
            this.refreshTableData();
		},
		handleSortChange( {prop, order} ) {
			this.sortingProp = prop
			this.sortingOrder = order
		},
		handleSelectChange (rows) {
            this.selectedItems = rows;
            this.showDelete = this.selectedItems.length > 0;
        },
        refreshTableData(){
			if(this.refreshListEvent)
            {
                this.refreshTable(true);
                this.$emit(this.refreshListEvent);
            }
		},
		refreshTable(refresh) {
            this.asyncComponent = refresh ? null : 'v2-table';
            this.loading = refresh;
        },
        tableRefreshed(result){
			this.list = [];
            this.list = result.items;
            this.paginationInfo = result.paginationInfo;

            this.refreshTable(false);
            
            this.$emit(this.paginationEvent);
            this.calcDims();
        },
		downloadCSV(data) {
			var dataCSV = Papa.unparse(data, {header: true});
			const blob = new Blob([dataCSV], {type: 'text/csv;charset=utf-8'})
			FS.saveAs(blob, 'list.csv')
		},
		calcDims() {
            if(document.getElementById('table-wrapper')){
                this.width = document.getElementById('table-wrapper').clientWidth
            }
            
            

			if(!this.isMobile) {
                if(document.getElementById('table-wrapper')){
                    this.height = document.getElementById('table-wrapper').clientHeight - 40;
                }
				
				if(this.showSummary) this.height -= 40
				if(this.shownPagination) this.height -= 40
			}

			this.asyncComponent = 'v2-table'
		},
		handleResize: _.throttle(function (e) {
			this.asyncComponent = null
			this.width = 0
			this.currentPage = 1
			setTimeout(this.calcDims,1000)
		}, 500)
	},
    filters: {
		selected: function (value, sel) {
			if (!value) return ''
			if (!sel) return value
			return value.toString().replace(new RegExp(sel,"gim"), `<span class="sel">${sel}</span>`)
		}
	},
    created() {
        if(window.innerWidth <= 768) 
            this.isMobile = true	
            
        this.$on(this.paginationEvent, this.updatePaginationText);
	},
	mounted() {
		//ie fix
		if(!window.Number.parseInt) window.Number.parseInt = parseInt
	}
}